import React, { Component } from 'react';
import { number, shape } from 'prop-types';
import { numberWithCommas } from 'ps-components/lib/formatters';
import Cell from 'ps-components/Table/Cell/Cell';
import Row from 'ps-components/Table/Row/Row';
import Table from 'ps-components/Table/Table/Table';
import TableBody from 'ps-components/Table/TableBody/TableBody';
import TableHeader from 'ps-components/Table/TableHeader/TableHeader';
import './MarketPricingTable.scss';

class MarketPricingTable extends Component {
  static propTypes = {
    data: shape({
      market_base_salary_25th: number,
      market_base_salary_50th: number,
      market_base_salary_75th: number
    })
  };

  getColumnHeaders = columns => {
    return columns.map(column => {
      let index = column.lastIndexOf('_');
      return column.substr(index + 1);
    });
  };

  renderMarketPricingTable = () => {
    const { data } = this.props;
    return (
      <div className="market__pricing-table-container">
        <div className="market__pricing-row-desc">Base Salary</div>
        <Table className="market__pricing-table">
          <TableHeader cellClass="market__pricing-header-cell" columns={this.getColumnHeaders(Object.keys(data))} />
          <TableBody>
            <Row className="market__pricing-row">
              {Object.values(data).map((datum, index) => (
                <Cell className="market__pricing-body-cell pxl-header-xsmall" key={index}>
                  {numberWithCommas(Math.round(datum))}
                </Cell>
              ))}
            </Row>
          </TableBody>
        </Table>
      </div>
    );
  };

  renderNoDataPlaceholder = () => {
    return <div className="pxl-header-xxsmall market__pricing-no-data">There is no market pricing for this job.</div>;
  };

  render() {
    const { data } = this.props;
    const jobNotPriced = !Object.keys(data).length;

    return (
      <div className="market__pricing-container">
        <div className="market__pricing-title">Market Pricing</div>
        {jobNotPriced ? this.renderNoDataPlaceholder() : this.renderMarketPricingTable()}
      </div>
    );
  }
}

export default MarketPricingTable;
